import { createFileRoute, Link } from "@tanstack/react-router";
import { useState, useMemo } from "react";
import { ChevronLeft } from "lucide-react";
import { PageHeader } from "@/components/app-shell";
import { CalcShell, Field, NumberInput, ResultCard, fmt } from "@/components/calculators/CalcShell";
import { AddToQuoteButton } from "@/components/calculators/AddToQuoteButton";
import { linesFromGrus } from "@/components/calculators/lineMappers";
import { grusCalc } from "@/domain/calculators/carpenter";

export const Route = createFileRoute("/_authenticated/calculations/carpenter/grus")({
  component: GrusPage,
});

function GrusPage() {
  const [area, setArea] = useState<number | "">("");
  const [tykkelse, setTykkelse] = useState<number | "">(150);
  const [komp, setKomp] = useState<number | "">(20);

  const r = useMemo(() => {
    if (area === "" || tykkelse === "") return null;
    return grusCalc({
      areal_m2: Number(area),
      tykkelse_mm: Number(tykkelse),
      komprimering_pct: komp === "" ? undefined : Number(komp),
    });
  }, [area, tykkelse, komp]);

  return (
    <>
      <Link to="/calculations" className="mb-4 inline-flex items-center text-sm text-muted-foreground hover:text-foreground">
        <ChevronLeft className="h-4 w-4" /> Beregninger
      </Link>
      <PageHeader title="Grus / pukk" subtitle="Beregn volum og tonn løsmasse." />
      <CalcShell
        title="Inndata"
        result={r ? (
          <>
            <ResultCard
            title="Materialbehov"
            rows={[
              { label: "Volum (bulk)", value: `${fmt(r.volum_m3, 2)} m³`, strong: true },
              { label: "Vekt",         value: `${fmt(r.tonn, 2)} tonn` },
            ]}
            note="~1,7 tonn/m³ for komprimert pukk 8/22. Justér komprimering etter fraksjon."
          />
            <div className="mt-3 flex justify-end">
              <AddToQuoteButton sourceLabel={`Grus/pukk`} lines={linesFromGrus(r)} defaultLaborHours={Math.max(0, Math.round((r.volum_m3 * 1.5) * 10) / 10)} />
            </div>
          </>
        ) : <div className="card p-5 text-sm text-muted-foreground">Fyll inn areal og tykkelse.</div>}
      >
        <Field label="Areal" unit="m²"><NumberInput value={area} onChange={setArea} /></Field>
        <Field label="Tykkelse" unit="mm"><NumberInput value={tykkelse} onChange={setTykkelse} /></Field>
        <Field label="Komprimering­tillegg" unit="%"><NumberInput value={komp} onChange={setKomp} /></Field>
      </CalcShell>
    </>
  );
}
